import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { useState } from "react";
import classes from "./styles.module.scss";
import { CollapsibleSectionItem, Description, Title } from "@/ui";

export const Dropdown = ({
  className,
  title,
  body,
  items,
  defaultActiveKey,
  bgColor,
  titleColor,
  textColor,
}) => {
  const [active, setActive] = useState(defaultActiveKey);

  if (
    items
      .map((i) => i.title)
      .join("")
      .trim().length === 0
  ) {
    return null;
  }

  return (
    <div className={clsx(className, classes.collapsible, `bg-${bgColor}`)}>
      <Container className="mw-xxl">
        <h1 className={clsx(`text-${titleColor}`)}>{title}</h1>
        <Description description={body} className={clsx(`text-${textColor}`)} />
        <Row>
          <Col xs={12}>
            {items.map(({ title, body }, k) => (
              <CollapsibleSectionItem
                key={k}
                title={title}
                body={body}
                active={k === active}
                onClick={() => setActive(k === active ? null : k)}
              />
            ))}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Dropdown;
